import React from 'react';

interface SectionTitleProps {
  title: string;
  centered?: boolean;
  className?: string;
}

export function SectionTitle({ title, centered = false, className }: SectionTitleProps) {
  return (
    <div className={`${className} ${centered ? 'text-center' : 'text-left'} mb-2`}>
      <div className="uppercase text-gray-500 text-[10px]">[ {title} ]</div>
    </div>
  );
}
